import { Component, Input, OnInit, Output, EventEmitter, OnChanges } from '@angular/core';
import { IAllSpecs } from 'src/app/model/http/specs.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-car-features',
  templateUrl: `./car-features.component${environment.templateSuffix}.html`,
  styleUrls: ['./car-features.component.scss']
})
export class CarFeaturesComponent implements OnInit, OnChanges {
  @Output() public scrollToSpecs = new EventEmitter();
  @Input() specs: any;
  car!: any;
  features!: IAllSpecs;
  carPower: string = '';
  carAceleration: string = '';
  carTorque: string = '';
  carTransmition: string = '';
  carMotor: string = '0';
  carLitros: string = '0'
  carVelocidades: string = '0';
  templateSuffix: string = '';

  constructor() {
    this.templateSuffix = environment.templateSuffix;
  }


  ngOnInit(): void {
    this.initProps();
  }

  ngOnChanges() {
    this.initProps();
  }

  initProps() {
    this.carMotor = this.specs.motor.especificaciones[0].split(':')[1] || '0';
    this.carVelocidades = this.specs.transmision.especificaciones[1].split(':')[1] || '0';
    this.carPower = this.specs.motor.especificaciones[1].split(':')[1] || '0';
    this.carTransmition = this.specs.transmision.especificaciones[0].split(':')[1] || '-'
  }

}
